
export default function CardContenedor({children}) {

    return (
        <div className="row">
            <div className="d-flex justify-content-center mt-4 mb-5">
                <div className="col-md-8 col-12">
                    <div className="card card-body py-5">
                        { children }
                    </div>
                </div>
            </div>
        </div>
    )
}
